import { render, staticRenderFns } from "./PDFReader.vue?vue&type=template&id=e9f1c6f2&"
import script from "./PDFReader.vue?vue&type=script&lang=js&"
export * from "./PDFReader.vue?vue&type=script&lang=js&"
import style0 from "./PDFReader.vue?vue&type=style&index=0&id=e9f1c6f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports